require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-how-i-stay-up-to-date-on-rails.json") })
        }
      }, "path---blog-how-i-stay-up-to-date-on-rails");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-how-i-stay-up-to-date-on-rails!./.cache/json/blog-how-i-stay-up-to-date-on-rails.json
// module id = 841
// module chunks = 231608221292675